/**
 * Checks for the internationalization values OneStone stores — a time zone
 * (routines, the operator profile) and a locale tag (the operator profile).
 * Both use the runtime's own `Intl` data, the same data that later formats
 * dates in that zone, so a value accepted here is one the runtime can use.
 */

/** Whether `timeZone` is an IANA time zone this runtime knows (e.g. America/New_York). */
export function isKnownTimeZone(timeZone: string): boolean {
  if (timeZone.trim() === '') return false;
  try {
    new Intl.DateTimeFormat('en-US', { timeZone });
    return true;
  } catch {
    return false;
  }
}

/** Whether `tag` is a well-formed BCP 47 locale tag (e.g. en-US). */
export function isWellFormedLocale(tag: string): boolean {
  if (tag.trim() === '') return false;
  try {
    return Intl.getCanonicalLocales(tag).length === 1;
  } catch {
    return false;
  }
}
